<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar tw-flex tw-items-center tw-gap-2" :class="{ 'sa-topbar': isSuperAdmin }">
    <div
      class="d-flex align-items-center mx-1 tw-flex tw-items-center"
      v-if="!isSuperAdmin && showBranchSelect && $canUseMultilocations()"
    >
      <!-- Branch Selector (Shown Only if BRANCHES_COUNT > 0) -->
      <div class="ml-2 d-flex align-items-center branch-selector">
        <label class="mr-2 my-1 responsive-text branch-label">Branch:</label>
        <div class="branch-dropdown-wrapper">
          <select v-model="selectedBranch" @change="onBranchChange" class="form-control branch-select">
            <option value="0">{{ main_branch.name }} - {{ main_branch.address }} (Main)</option>
            <option v-for="branch in branches" :key="branch.id" :value="branch.id">
              {{ branch.name }} - {{ branch.address }}
            </option>
          </select>
          <i class="fa fa-chevron-down branch-dropdown-arrow"></i>
        </div>
      </div>
    </div>

    <!-- Globe Icon -->
    <button
      type="button"
      class="biz-globe-btn tw-inline-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-shadow-sm"
      v-if="$store.state.auth.normal && !isAgentUser"
      @click="takeMeToWeb"
      title="View Website"
      aria-label="View Website"
    >
      <i class="fa fa-globe" aria-hidden="true"></i>
    </button>

    <div v-if="isSuperAdmin" class="sa-notify" title="Notifications">
      <i class="mdi mdi-bell-outline"></i>
      <span class="sa-notify-badge">3</span>
    </div>

    <div
      v-if="isSuperAdmin"
      class="sa-user-chip"
      @click="openQuickUser"
    >
      <div class="sa-avatar">SA</div>
      <div class="sa-user-meta d-none d-sm-block">
        <div class="sa-user-name">Super Admin</div>
        <div class="sa-user-role">Administrator</div>
      </div>
      <i class="mdi mdi-chevron-down sa-user-caret d-none d-sm-inline"></i>
    </div>

    <KTQuickUser ref="quickUser" :hide-toggle="isSuperAdmin"></KTQuickUser>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;

    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;

    .b-dropdown-text {
      padding: 0;
    }
  }

  /* Enhanced Branch Selector Styling */
  .branch-selector {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
    border-radius: 12px;
    padding: 10px 16px;
    border: 1px solid rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(15px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

    &:hover {
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%);
      border-color: rgba(255, 255, 255, 0.4);
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
      transform: translateY(-1px);
    }

    .branch-label {
      font-weight: 700;
      font-size: 14px;
      margin: 0;
      white-space: nowrap;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      letter-spacing: 0.5px;
    }

    .branch-dropdown-wrapper {
      position: relative;
      display: inline-block;

      .branch-select {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        border: 2px solid rgba(255, 255, 255, 0.4);
        border-radius: 10px;
        color: #2d3748;
        font-size: 13px;
        font-weight: 500;
        padding: 8px 40px 8px 12px;
        min-width: 220px;
        max-width: 280px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        cursor: pointer;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

        &:focus {
          background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
          border-color: #241B5A;
          box-shadow: 0 0 0 4px rgba(36, 27, 90, 0.15), 0 4px 15px rgba(0, 0, 0, 0.1);
          outline: none;
          transform: translateY(-1px);
        }

        &:hover {
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
          border-color: rgba(255, 255, 255, 0.6);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
          transform: translateY(-1px);
        }

        /* Custom dropdown options styling */
        option {
          background: white;
          color: #2d3748;
          padding: 8px 12px;
          font-weight: 500;

          &:hover {
            background: #241B5A;
            color: white;
          }
        }

        /* Remove default arrow in IE */
        &::-ms-expand {
          display: none;
        }
      }

      .branch-dropdown-arrow {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #241B5A;
        font-size: 14px;
        font-weight: bold;
        pointer-events: none;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      }

      &:hover .branch-dropdown-arrow {
        transform: translateY(-50%) rotate(180deg);
        color: #16124a;
      }

      .branch-select:focus+.branch-dropdown-arrow {
        color: #16124a;
        transform: translateY(-50%) scale(1.1);
      }
    }
  }

  /* Globe Icon Styling */
  .globe-icon {
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }

    &:active {
      transform: scale(0.95);
    }
  }

  /* Branch label follows the white header, not the old dark Metronic bar */
  .responsive-text {
    color: #475569 !important;
  }
}

/* Mobile Responsive Design */
@media (max-width: 768px) {
  .topbar {
    .branch-selector {
      margin: 4px 0;
      padding: 8px 12px;
      border-radius: 10px;
      flex-direction: row !important;
      align-items: center !important;
      gap: 8px;
      background: transparent !important;
      border: none !important;
      backdrop-filter: none !important;
      box-shadow: none !important;

      .branch-label {
        font-size: 12px;
        margin-right: 0;
        margin-bottom: 0;
        font-weight: 600;
        white-space: nowrap;
      }

      .branch-dropdown-wrapper {
        flex: 1;

        .branch-select {
          min-width: 160px;
          max-width: 200px;
          font-size: 12px;
          padding: 6px 35px 6px 10px;
          border-radius: 8px;
          border-width: 1.5px;
        }

        .branch-dropdown-arrow {
          font-size: 12px;
          right: 10px;
          display: block !important;
        }
      }
    }
  }
}

@media (max-width: 576px) {
  .topbar {
    .branch-selector {
      flex-direction: row !important;
      align-items: center !important;
      gap: 6px;
      padding: 4px 0;
      border-radius: 0;
      background: transparent !important;
      border: none !important;
      backdrop-filter: none !important;
      box-shadow: none !important;

      .branch-label {
        font-size: 11px;
        margin-bottom: 0;
        margin-right: 0;
        font-weight: 600;
        white-space: nowrap;
      }

      .branch-dropdown-wrapper {
        flex: 1;

        .branch-select {
          min-width: 130px;
          max-width: 160px;
          font-size: 11px;
          padding: 5px 30px 5px 8px;
          border-radius: 6px;
          border-width: 1.5px;
        }

        .branch-dropdown-arrow {
          font-size: 10px;
          right: 8px;
          display: block !important;
        }
      }
    }

    /* Responsive text behavior for small screens */
    .responsive-text {
      color: var(--primary) !important;
    }
    
    /* Small icon padding override for mobile */
    .smallIcon {
      padding-top: 0.25rem !important;
      padding-bottom: 0.25rem !important;
    }
  }

  
}

.topbar {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.sa-topbar {
  display: flex;
  align-items: center;
  gap: 14px;
}

.biz-globe-btn {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  margin: 0 4px 0 0;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.biz-globe-btn:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.biz-globe-btn i {
  font-size: 18px;
  color: #475569 !important;
}

.sa-notify {
  position: relative;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  cursor: pointer;
}

.sa-notify i {
  font-size: 22px;
  color: #475569 !important;
}

.sa-notify-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #241B5A;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

.sa-user-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 4px 8px 4px 4px;
  border-radius: 999px;
  transition: background 0.2s ease;
}

.sa-user-chip:hover {
  background: #f8fafc;
}

.sa-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #241B5A, #241B5A);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}

.sa-user-name {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.sa-user-role {
  font-size: 11px;
  color: #94a3b8;
  line-height: 1.2;
}

.sa-user-caret {
  color: #94a3b8;
  font-size: 18px;
}
</style>

<script>
import { mapGetters } from "vuex";
//import KTSearchDefault from "@/view/layout/extras/dropdown/SearchDefault.vue";
import KTDropdownNotification from "@/view/layout/extras/dropdown/DropdownNotification.vue";
//import KTDropdownQuickAction from "@/view/layout/extras/dropdown/DropdownQuickAction.vue";
//import KTDropdownMyCart from "@/view/layout/extras/dropdown/DropdownMyCart.vue";
//import KTDropdownLanguage from "@/view/layout/extras/dropdown/DropdownLanguage.vue";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
//import KTQuickPanel from "@/view/layout/extras/offcanvas/QuickPanel.vue";
import ApiService from "@/core/services/api.service";
import i18nService from "@/core/services/i18n.service.js";
import { authGet, authSet } from "@/core/services/auth-storage";

export default {
  name: "KTTopbar",
  data() {
    return {
      languageFlag: "",
      showBranchSelect: false,
      selectedBranch: null,
      main_branch: null,
      branches: [],
      languages: i18nService.languages
    };
  },
  components: {
    //KTSearchDefault,
    KTDropdownNotification,
    //KTDropdownQuickAction,
    //KTDropdownMyCart,
    //KTDropdownLanguage,
    KTQuickUser,
    //KTQuickPanel
  },
  mounted() {
    this.checkBranchCount();
    this.checkSelectedBranch();
    try {
      this.main_branch = JSON.parse(authGet("MAIN_BRANCH") || "null");
    } catch (e) {
      this.main_branch = null;
    }
    // console.log(JSON.parse(this.main_branch).name);
  },
  methods: {
    onLanguageChanged() {
      this.languageFlag = this.languages.find(val => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },
    checkBranchCount() {
      const branchCount = authGet("BRANCHES_COUNT");

      console.log('BRANCHES_COUNT', branchCount, 12);
      if (branchCount && parseInt(branchCount) > 0) {
        this.showBranchSelect = true;
        this.loadBranches(); // Call API to populate branches
      }
    },
    loadBranches() {
      ApiService.get("business/branches").then(({ data }) => {
        this.branches = data.data; // Assuming API returns { data: [{id: 1, name: 'Branch 1'}, ...] }
        this.selectedBranch = authGet("SELECTED_BRANCH") || "0";
      });
    },
    onBranchChange() {
      authSet("SELECTED_BRANCH", this.selectedBranch);
      location.reload(); // Reload the page
    },
    checkSelectedBranch() {
      const storedBranch = authGet("SELECTED_BRANCH");
      this.selectedBranch = storedBranch !== null ? storedBranch : "0";
    },
    takeMeToWeb() {
      console.log(this.currentUserPersonalInfo.store_url);
      window.open(this.currentUserPersonalInfo.store_url, '_blank');
    },
    openQuickUser() {
      if (this.$refs.quickUser && this.$refs.quickUser.toggleQuickUser) {
        this.$refs.quickUser.toggleQuickUser();
      }
    }
  },
  computed: {
    ...mapGetters([
      "currentUserPersonalInfo",
    ]),
    getLanguageFlag() {
      return this.onLanguageChanged();
    },
    isSuperAdmin() {
      return this.$store.state.auth.isAuthenticated && !this.$store.state.auth.normal;
    },
    // Computed property to check if user is an agent
    isAgentUser() {
      return (this.$store.state.auth.user && this.$store.state.auth.user.user_type === 'AGENT') ||
             authGet('is_agent') === '1';
    }
  }
};
</script>
